import type { HeaderVariantType } from './Header';

/**
 * 원본 Emotion 의 .isActive 는 클래스 셀렉터였다.
 * Tailwind 를 important 로 임포트하고 있어 경쟁하는 색상 유틸리티의 승자가
 * CSS 출력 순서로 정해지므로, 활성 여부는 여기서 분기해 하나만 붙인다.
 *
 * variables.apps.mobile-header-height: 60px
 */

export const headerContainer = (
  isVisible: boolean,
  variant: HeaderVariantType,
) =>
  [
    'fixed left-0 top-0 z-[99] flex w-full flex-col transition-[translate,background-color] duration-300 motion-reduce:transition-none',
    isVisible ? 'translate-y-0' : '-translate-y-full',
    variant === 'transparent' ? 'bg-transparent' : 'bg-apps-coreGrayWhite',
  ].join(' ');

export const headerTop =
  'relative flex h-[60px] items-center justify-between';

/*
 * 트랜지션은 globals.css 의 클래스를 쓴다.
 * visibility 가 discrete 속성이라 duration 0s + delay 조합이 필요한데,
 * arbitrary property 값에 쉼표가 들어가면 Tailwind 클래스 생성이 깨져
 * 같은 요소의 다른 유틸리티(left-0, opacity-100)까지 함께 유실된다.
 */
export const asideContainer = (isOpen: boolean) =>
  [
    'fixed inset-x-0 -top-[60px] z-[10000] flex h-[calc(100vh+60px)] w-full flex-col items-start bg-apps-coreGrayWhite pt-[60px]',
    isOpen
      ? 'visible opacity-100 pointer-events-auto mobile-menu-transition-open'
      : 'invisible opacity-0 pointer-events-none mobile-menu-transition-closed',
  ].join(' ');

export const selectLanguageWrapper = 'flex h-[60px] items-center pl-5';

export const navContainer = 'h-full w-full overflow-y-auto';

export const navList = 'w-full';

export const depth1Container = 'w-full';

export const depth1Item = (isActive: boolean) =>
  [
    'flex w-full min-w-0 cursor-pointer items-center justify-between gap-2 border-0 bg-transparent px-6 py-4 text-left font-[inherit] text-xl font-bold leading-[160%] tracking-[-0.4px] transition-colors duration-300',
    isActive ? 'text-apps-corePrimary01' : 'text-apps-coreGrayBlack',
  ].join(' ');

export const depth2Container = (isActive: boolean) =>
  [
    'flex flex-col gap-1 overflow-hidden transition-[max-height] duration-500 ease-[ease]',
    isActive ? 'max-h-[370px] py-2' : 'max-h-0 py-0',
  ].join(' ');

export const depth2Item = (isActive: boolean) =>
  [
    'flex min-h-12 w-full items-center px-10 py-3 text-lg font-medium leading-[150%] tracking-[-0.36px] touch-manipulation',
    isActive ? 'text-apps-corePrimary01' : 'text-apps-coreGray02',
  ].join(' ');

export const socialLinksContainer = 'mt-auto w-full p-6';

export const socialLinks = 'flex items-center gap-4';

export const socialLink =
  'text-apps-coreGrayBlack transition-colors duration-200 hover:text-apps-corePrimary01';
